"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.manageYourTeamConstants = void 0;
const manageYourTeamConstants = exports.manageYourTeamConstants = {
  SEND_INVITATION_TOAST_MESSAGE: 'Success, your invitation has been sent'
};